import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import { AuthControl, userManager } from '@/services/SecurityService';
import { checkRegionNotSelected } from '@/services/helper.service';

Vue.use(Router);

const ifUserLoggedIn = (to, from, next) => {
  let auth = new AuthControl();
  // check if user is logged in
  auth.getSignedIn().then(res => {
    if (res) {
      next();
    } else {
      store.dispatch('logOutUser');
      userManager.signoutRedirect();
      userManager.removeUser();
      next({ name: 'landing' });
    }
  });
};

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'landing',
      component: () => import(/* webpackChunkName: "landing" */ '@/views/landing/LandingPage.vue')
    },
    {
      path: '/home',
      name: 'home',
      meta: { persistExpandedMenu: true },
      beforeEnter: ifUserLoggedIn,
      component: () => import(/* webpackChunkName: "home" */ '@/views/unit/Home.vue')
    },
    {
      path: '/home/unit/addUnit',
      name: 'addUnit',
      beforeEnter: ifUserLoggedIn,
      component: () => import(/* webpackChunkName: "addUnit" */ '@/views/unit/AddUnit.vue')
    },
    {
      path: '/home/unit/edit/:id',
      name: 'updateUnit',
      beforeEnter: ifUserLoggedIn,
      component: () => import(/* webpackChunkName: "updateUnit" */ '@/views/unit/EditUnit.vue')
    },
    {
      path: '/home/unit/machine/:id/:unitId',
      name: 'machine',
      meta: { persistExpandedMenu: true },
      beforeEnter: ifUserLoggedIn,
      component: () => import(/* webpackChunkName: "machine" */ '@/views/unit/Machine.vue')
    },
    {
      path: '/home/unit/maintenance/:id/:unitId',
      name: 'maintenance',
      meta: { persistExpandedMenu: true },
      beforeEnter: ifUserLoggedIn,
      component: () => import(/* webpackChunkName: "maintenance" */ '@/views/unit/Maintenance.vue')
    },
    {
      path: '/specification',
      name: 'specification',
      beforeEnter: ifUserLoggedIn,
      component: () => import(/* webpackChunkName: "specification" */ '@/views/specification/Specification.vue')
    },
    {
      path: '/specification/add',
      name: 'addSpecification',
      beforeEnter: ifUserLoggedIn,
      component: () => import(/* webpackChunkName: "addSpecification" */ '@/views/specification/AddSpecification.vue')
    },
    {
      path: '/specification/edit/:id',
      name: 'editSpecification',
      beforeEnter: ifUserLoggedIn,
      component: () => import(/* webpackChunkName: "editSpecification" */ '@/views/specification/EditSpecification.vue')
    },
    {
      path: '/schedule',
      name: 'schedule',
      beforeEnter: ifUserLoggedIn,
      component: () => import(/* webpackChunkName: "schedule" */ '@/views/common/Schedule.vue')
    },
    {
      path: '/recommendations',
      name: 'recommendations',
      beforeEnter: ifUserLoggedIn,
      component: () => import(/* webpackChunkName: "recommendations" */ '@/views/common/Recommendations.vue')
    },
    {
      path: '/news',
      name: 'news',
      beforeEnter: ifUserLoggedIn,
      component: () => import(/* webpackChunkName: "news" */ '@/views/common/News.vue')
    },
    {
      path: '/notification-settings',
      name: 'notification-settings',
      beforeEnter: ifUserLoggedIn,
      component: () => import(/* webpackChunkName: "notification-settings" */ '@/views/common/NotificationSettings.vue')
    },
    {
      path: '/logData',
      name: 'logData',
      beforeEnter: ifUserLoggedIn,
      component: () => import(/* webpackChunkName: "logData" */ '@/views/common/LogData.vue')
    },
    {
      path: '/profile',
      name: 'profile',
      beforeEnter: ifUserLoggedIn,
      component: () => import(/* webpackChunkName: "profile" */ '@/views/common/Profile.vue')
    },
    {
      path: '/404',
      name: 'error',
      component: () => import(/* webpackChunkName: "error" */ '@/components/NotFound')
    },
    { path: '*', redirect: '/404' }
  ]
});

router.beforeEach((to, from, next) => {
  if (checkRegionNotSelected()) {
    store.commit('setRegionsNotSelected', true);
  }
  store.commit('setPageHaveExpandedDashboard', to.meta.persistExpandedMenu === true);
  next();
});

export { router };
